<template>
	<div id="container-main">
		<div id="container-cards">
			<div class="queue-calls-today">
				<div class="title-loading">
					<h3>Ligações deste Mês</h3>
					<button v-show="loading[0]" class="btn btn-outline-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
						Aguarde, carregando dados...
					</button>
				</div>

				<div>
					<div class="calls-today border-incoming">
						<div>
							<h5 class="">Ligações Recebidas</h5>
							<span class="value">{{ callsMonth.incoming }}</span>
						</div>
						<div>
							<i class="fas fa-phone incoming"></i>
						</div>
					</div>

					<div class="calls-today border-answered">
						<div>
							<h5>Ligações Atendidas</h5>
							<span class="value">{{ callsMonth.answered }}</span>
						</div>
						<div>
							<i class="fas fa-phone-volume answered" style="padding: 10px 12px; font-size: 1.4em"></i>
						</div>
					</div>

					<div class="calls-today border-missed">
						<div>
							<h5>Ligações Abandonadas</h5>
							<span class="value">{{ callsMonth.abandon }}</span>
						</div>
						<div>
							<i class="fas fa-phone-slash missed"></i>
						</div>
					</div>

					<div class="calls-today border-missed-percent">
						<div>
							<h5>% de Abandonadas</h5>
							<span class="value">{{ callsMonth.abandonPercent }}%</span>
						</div>
						<div>
							<i class="fas fa-percent missed-percent"></i>
						</div>
					</div>
				</div>

			</div>

			<div class="queue-calls-today">
				<div class="title-loading">
					<h3>Ligações de Hoje</h3>
					<button v-show="loading[1]" class="btn btn-outline-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
						Aguarde, carregando dados...
					</button>
				</div>

				<div>
					<div class="calls-today border-incoming">
						<div>
							<h5 class="">Ligações Recebidas</h5>
							<span class="value">{{ callsToday.incoming }}</span>
						</div>
						<div>
							<i class="fas fa-phone incoming"></i>
						</div>
					</div>

					<div class="calls-today border-answered">
						<div>
							<h5>Ligações Atendidas</h5>
							<span class="value">{{ callsToday.answered }}</span>
						</div>
						<div>
							<i class="fas fa-phone-volume answered" style="padding: 10px 12px; font-size: 1.4em"></i>
						</div>
					</div>

					<div class="calls-today border-missed">
						<div>
							<h5>Ligações Abandonadas</h5>
							<span class="value">{{ callsToday.abandon }}</span>
						</div>
						<div>
							<i class="fas fa-phone-slash missed"></i>
						</div>
					</div>

					<div class="calls-today border-missed-percent">
						<div>
							<h5>% de Abandonadas</h5>
							<span class="value">{{ callsToday.abandonPercent }}%</span>
						</div>
						<div>
							<i class="fas fa-percent missed-percent"></i>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import moment from 'moment'
import momentDuration from "moment-duration-format";
momentDuration(moment);

export default {
	props: ["update"],
	data: function () {
		return {
			realtime: null,
			loading: [false, false],
			callsToday: {
				incoming: 0,
				answered: 0,
				abandon: 0,
				abandonPercent: 0
			},
			callsMonth: {
				incoming: 0,
				answered: 0,
				abandon: 0,
				abandonPercent: 0
			},
		};
	},
	methods: {
		formatDuration(date) {
			return date >= 86400 ?
				moment.duration(date, "seconds").format('hh:mm:ss').replace(',', '.') :
				moment.utc(date * 1000).format('HH:mm:ss')
		},
		getCallsData() {
			this.loading = [true, true];
			const filter = $('#selectedQueuesOnly').serialize();
			console.log('filter', filter);
			axios.get(`call_control/callsToday?${filter}`)
				.then(({ data }) => {
					this.callsToday = data;
					this.loading[1] = false;
				}).catch(() => this.loading[1] = false);

			axios.get(`call_control/callsMonth?${filter}`)
				.then(({ data }) => {
					this.callsMonth = data;
					this.loading[0] = false;
				}).catch(() => this.loading[0] = false);
		},
		updateRealtime() {
			clearInterval(this.realtime);
			this.realtime = setInterval(() => {
				this.getCallsData();
			}, 60000);
		}

	},
	beforeMount() {
		this.getCallsData();
	},
	created() {
		this.updateRealtime();
	},
	watch: {
		update() {
			this.getCallsData();
		}
	}
};
</script>

<style scoped>
.title-loading {
	align-self: baseline;
}

.title-loading>button {
	border-radius: 10px !important;
	margin-left: 20px;
}

#container-main {
	display: flex;
}

#container-cards {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	width: 100%;
}

#container-cards form {
	width: 50%;
}

.btn-small-form {
	margin-top: 33px;
}

.queue-calls-today h2 {
	margin-bottom: 20px;
}

.value {
	font-size: 30px;
}

.incoming {
	background-color: #0077b6;
}

.border-incoming {
	color: #0077b6;
	border-bottom: solid 2px #0077b6;
}

.answered {
	background-color: #2d6a4f;
}

.border-answered {
	color: #2d6a4f;
	border-bottom: solid 2px #2d6a4f;
}

.missed {
	background-color: #c1121f;
}

.border-missed {
	color: #c1121f;
	border-bottom: solid 2px #c1121f;
}

.missed-percent {
	background-color: #5e548e;
}

.border-missed-percent {
	color: #5e548e;
	border-bottom: solid 2px #5e548e;
}

.queue-calls-today {
	display: flex;
	flex-direction: column;
	padding: 20px;
	margin-bottom: 20px;
	background-color: white;
	width: 100%;
	border-radius: 12px;
	box-shadow: -5px -5px 8px rgba(255, 255, 255, 1),
		-2px -2px 12px rgba(255, 255, 255, 0.5),
		inset 2px 2px 4px rgba(255, 255, 255, 0.1),
		5px 5px 8px rgba(0, 0, 0, 0.15);
}

.op-prod {
	height: 820px;
}

.queue-calls-today>div {
	display: flex;
	justify-content: space-around;
	flex-wrap: wrap;
}

.calls-today {
	display: flex;
	padding: 10px;
	justify-content: space-between;
	width: 23%;
}

.calls-today i {
	color: white;
	font-size: 1.2em;
	border-radius: 100%;
	padding: 10px;
}

.special-table tr:nth-child(even) {
	background-color: rgba(0, 0, 0, 0.05);
}

.special-table tr>th:first-child {
	border-radius: 15px 0px 0px 0px;
}

.special-table tr>th:last-child {
	border-radius: 0px 15px 0px 0px;
}

.special-table {
	width: 100%;
	margin-top: 20px;
	font-size: 1em;
	font-family: "Sulphur Point", sans-serif;
	border-bottom: solid 2px black;
}

.special-table th {
	background-color: #dec9e9;
	color: white;
	padding: 5px 20px;
	font-weight: bold;
}

.special-table tfoot {
	background-color: black;
}

.special-table>tr:hover {
	background-color: rgba(0, 0, 0, 0.1);
}

.operator-card {
	display: flex;
	background-color: white;
	flex-direction: column;
	margin-bottom: 10px;
	border-radius: 5px;
	box-shadow: 2px 2px 5px black;
}

.personal-data {
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: deepskyblue;
	color: white;
}

.operator-card>.productivity {
	padding: 0px 20px;
}

.fixTableHead {
	overflow-y: auto;
}

.fixTableHead thead th {
	position: sticky;
	top: 0;
}
</style>
